import * as React from 'react';
import { useTranslation } from 'react-i18next';
import OptionModel from '@src/shared/src/models/OptionModel';

import Dropdown from './Dropdown';
import Checkbox from './Checkbox';

type Props = {
  label: string;
  name: string;
  options: OptionModel[];
  onChange: (options: string[]) => void;
  selectedOptions: string[];
  disabled?: boolean;
};

const CheckboxMultiSelect: React.FC<Props> = ({
  label,
  name,
  options,
  disabled,
  onChange,
  selectedOptions,
}) => {
  const { t } = useTranslation();

  const onChangeAll = () => {
    if (selectedOptions.length === 0) {
      onChange(options.map((option: OptionModel) => option.value));
    } else {
      onChange([]);
    }
  };

  const onChangeOption = (value: string, checked: boolean) => {
    if (checked) {
      onChange([...selectedOptions, value]);
    } else {
      onChange(selectedOptions.filter((option) => option !== value));
    }
  };

  return (
    <Dropdown label={label} className="type--select" disabled={disabled}>
      <div key={`${name}-all`} className="dropdown-option">
        <Checkbox
          id={`${name}-all`}
          label={t('global.all')}
          isChecked={selectedOptions.length > 0}
          onChange={() => onChangeAll()}
          checkedIcon={
            selectedOptions.length === options.length ? 'check_box' : 'indeterminate_check_box'
          }
        />
      </div>
      <hr />
      {options.map((option) => {
        return (
          <Checkbox
            key={`${name}-${option.value}`}
            id={`${label}-${option.value}`}
            label={option.label}
            isChecked={selectedOptions.includes(option.value)}
            onChange={(checked: boolean) => onChangeOption(option.value, checked)}
            outerCSS="dropdown-option"
          />
        );
      })}
    </Dropdown>
  );
};

export default CheckboxMultiSelect;
